import { api } from './client';

export interface TemplateVariables {
  guestName?: string;
  roomType?: string;
  checkinDate?: string;
  checkoutDate?: string;
  checkinTime?: string;
  checkoutTime?: string;
  reservationId?: string;
  roomAddress?: string;
  password?: string;
  bookingLink?: string;
  parkingLink?: string;
}

export interface SendMessageRequest {
  reservationId: string;
  phone: string;
  guestName: string;
  messageType: 'confirm' | 'checkin' | 'checkout' | 'review';
  isScheduled: boolean;
  scheduledTime?: string; // YYYY-MM-DD HH:MM:SS
  templateVariables: TemplateVariables;
}

export interface CancelMessageRequest {
  reservationId: string;
  messageType: 'checkin' | 'checkout' | 'review';
  channel: 'sms' | 'kakao';
}

export interface MessageLog {
  id: number;
  reservationId: string;
  templateId: string;
  recipient: string;
  messageContent: string;
  messageType: string;
  channel: string;
  messageKey?: string;
  scheduledAt?: string;
  isSent: boolean;
  sentAt?: string;
  errorMessage?: string;
  createdAt: string;
}

export const messagingApi = {
  // SMS 전송
  sendSms: async (request: SendMessageRequest) => {
    const response = await api.post('/messages/sms/send', request);
    return response.data;
  },

  // SMS 예약 취소
  cancelSms: async (request: CancelMessageRequest) => {
    const response = await api.post('/messages/sms/cancel', request);
    return response.data;
  },

  // 카카오톡 전송
  sendKakao: async (request: SendMessageRequest) => {
    const response = await api.post('/messages/kakao/send', request);
    return response.data;
  },

  // 카카오톡 예약 취소
  cancelKakao: async (request: CancelMessageRequest) => {
    const response = await api.post('/messages/kakao/cancel', request);
    return response.data;
  },

  // 메시지 이력 조회
  getMessageHistory: async (reservationId: string): Promise<MessageLog[]> => {
    const response = await api.get(`/messages/history/${reservationId}`);
    return response.data.data;
  },

  // 템플릿 조회
  getTemplate: async (templateId: string) => {
    const response = await api.get(`/messages/templates/${templateId}`);
    return response.data.data;
  },

  // 전체 템플릿 목록 조회
  getTemplates: async () => {
    const response = await api.get('/messages/templates');
    return response.data.data;
  },
};
